/**
 * Created by idea on 03/07/2017.
 */
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {AdminHeaderComponent} from './admin-header.component';
import {HelperModule} from '../../common/helper/helper.module';
import {FormsModule} from '@angular/forms';
import { MytabModule } from '../mytab/mytab.module';
import { TabsComponent } from '../tabs/tabs.component';

@NgModule({
    declarations: [AdminHeaderComponent],
    imports     : [BrowserModule, RouterModule,HelperModule,FormsModule, MytabModule],
    exports     : [AdminHeaderComponent]
})

export class HeaderModule {}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/layout/header/header.module.ts